/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * YC-29 PHẦN 2 — CƠ CHẾ POPUP. Sáu quy tắc của dev_device, không thêm không bớt.
 *
 * 🔴 LUẬT GỐC, chép lại vì mọi quyết định dưới đây đều quy về nó:
 *
 *   > Một popup hiện 50 lần một đêm sẽ bị bấm bỏ theo phản xạ. Lúc đó cái thứ 51 — cái
 *   > THẬT — cũng bị bấm bỏ.
 *
 *   ⇒ **Popup không phải kênh thông báo. Nó là kênh XIN MỘT HÀNH ĐỘNG NGAY.**
 *     Thứ gì không đòi hành động ngay thì không được popup.
 *
 * ─────────────────────────────────────────────────────────────────────────────────────
 * ⛔ VÌ SAO TỆP NÀY THUẦN (không `useState`, không JSX, không `window`):
 *
 * Sáu quy tắc này gồm hai cái **không thử được bằng tay**: gom theo cửa sổ 5 giây, và
 * ngưỡng bão 20 cảnh báo/60 giây. dev_device nói thẳng: *"600 tủ chưa bao giờ cùng lỗi một
 * lúc"* — nên phép thử duy nhất có thật là phép ÉP. Ép được thì logic phải tách khỏi React
 * và khỏi đồng hồ hệ thống ⇒ **mọi hàm dưới đây nhận `luc` làm tham số**, không gọi
 * `Date.now()` bên trong. Cùng khuôn `services/vaitro.ts` và `services/pha.ts`.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */

/** Một cảnh báo vừa tới, đúng hình dạng `appHub.broadcast({type:'cabinet.alarm'})` gửi lên. */
export interface CanhBaoToi {
  id: string;
  cabinetId: string;
  code: string;
  message?: string | null;
  /** ⛔ `null` = KHÔNG có mức riêng ⇒ tra `BANG_MUC` theo mã. Không phải mức 2. */
  mucDo: 1 | 2 | null;
  luc: number;
  /** TK-32 B.4: hồ sơ thuộc nhóm Mất kết nối (`laMatKetNoi`) — chỗ gọi tra, luật chỉ đọc. Vắng = không. */
  laMat?: boolean;
  /** TK-32 B.4: tuỳ chọn "popup cả Mất kết nối" của trình duyệt này (`lib/thongbao.ts`). Vắng = tắt. */
  popupMat?: boolean;
}

/* ─────────────────────────────────────────────────────────────── các mốc, đều là MỐC ĐẶT */

/** Quy tắc 2 — cửa sổ gom theo NGUYÊN NHÂN. */
export const CUA_SO_GOM_MS = 5_000;

/**
 * Quy tắc 5 — ngưỡng bão.
 *
 * ⚠ dev_device tự khai: *"20 cảnh báo / 60 giây là con số tôi đặt ra, KHÔNG đo được — nó
 *   phụ thuộc một tuyến của lee thường có bao nhiêu tủ trên cùng một lộ. Ghi rõ là mốc đặt."*
 *   Nên nó nằm ở đây thành hằng có tên, không rải trong nhánh `if` — đổi là một dòng, và
 *   ngày lee cho con số thật thì không ai phải đi tìm.
 */
export const NGUONG_BAO_SO = 20;
export const NGUONG_BAO_MS = 60_000;

/** Quy tắc 6 — mức thấp hơn tự tắt sau 8 giây; mức 1 KHÔNG BAO GIỜ tự tắt. */
export const TU_TAT_MUC_THAP_MS = 8_000;

/* ───────────────────────────────────────────────────────────────────────── trạng thái */

export interface Popup {
  /** Khoá gom = **mã cảnh báo**. Quy tắc 2: gom theo NGUYÊN NHÂN, không theo tủ. */
  code: string;
  /** Các tủ đang góp mặt trong popup này. `Set` vì quy tắc 4: cùng tủ vào lại thì không cộng. */
  tu: Set<string>;
  /** Hàng cảnh báo mới nhất của mã này — dùng cho nút "Xác nhận" (quy tắc 6). */
  idMoiNhat: string;
  moTa: string;
  moLuc: number;
  capNhatLuc: number;
}

export interface TrangThaiPopup {
  /** Quy tắc 3: MỘT popup tại một thời điểm. Cái đang hiện. */
  dangHien: Popup | null;
  /** Quy tắc 3: những cái sau xếp hàng, hiện thành huy hiệu `+n`. KHÔNG chồng cửa sổ. */
  hangCho: Popup[];
  /** Quy tắc 5: đang ở chế độ bão ⇒ thôi liệt kê, đổi sang MỘT dải. */
  bao: { tu: Set<string>; tuLuc: number } | null;
  /**
   * ═════════════════════════════════════════════════════════════════════════════════════
   * 🔴 ĐẾM **NHÓM MỚI MỞ**, KHÔNG ĐẾM CẢNH BÁO — và đây là chỗ đặc tả tự mâu thuẫn.
   *
   * Quy tắc 2 lấy ví dụ *"42 tủ cùng mã trong 5 giây ⇒ MỘT popup"*. Quy tắc 5 đặt ngưỡng
   * bão ở *"20 cảnh báo mức 1 trong 60 giây"*. Đếm từng cảnh báo thì **42 > 20 ⇒ vào bão
   * ngay**, và ví dụ của quy tắc 2 **không bao giờ hiện ra được**. Tôi dựng đúng chữ, chạy
   * phép thử, và nó đỏ — đó là cách tôi biết.
   *
   * ⇒ Giải theo LÝ DO quy tắc 5 tự khai: *"khi trời sập thì đếm từng viên gạch là vô ích"*.
   *   Cái vô ích là **LIỆT KÊ**. 42 cảnh báo cùng mã đã gộp thành MỘT dòng thì chẳng có gì
   *   đang được liệt kê cả — dải "SỰ CỐ DIỆN RỘNG" thay vào chỉ làm MẤT tên nguyên nhân.
   *   Ngưỡng phải đo *"có bao nhiêu THỨ KHÁC NHAU đang phải trình bày"*, tức số NHÓM.
   *
   *   · 137 tủ cùng mất công tơ  ⇒ 1 nhóm ⇒ popup *"137 tủ — mất số liệu công tơ trong N giây"*
   *     (nói được NGUYÊN NHÂN, mạnh hơn hẳn "sự cố diện rộng")
   *   · 21 mã khác nhau nổ cùng lúc ⇒ 21 nhóm ⇒ **bão**, vì lúc đó liệt kê mới thật sự vô ích.
   *
   * ⚠ Đây là QUYẾT ĐỊNH CỦA TÔI trên một chỗ đặc tả không tự nhất quán, không phải cách đọc
   *   duy nhất. dev_device bác thì đổi lại là một dòng — chỗ đếm nằm gọn ở `capNhatNhip()`.
   * ═════════════════════════════════════════════════════════════════════════════════════
   */
  nhipNhomMoi: number[];
}

export const trangThaiRong = (): TrangThaiPopup => ({
  dangHien: null, hangCho: [], bao: null, nhipNhomMoi: [],
});

/* ────────────────────────────────────────────────────────────────────────────── quy tắc */

/**
 * QUY TẮC 1 — chỉ mức 1 được popup.
 *
 * ⛔ `null` (không có mức riêng) **không** được coi là mức 1. Đây đúng chỗ L62 hay cắn:
 *   vắng mức KHÔNG phải "mức cao nhất", cũng không phải "mức 2" — nó là *"đọc bảng theo mã"*,
 *   và bảng ấy sống ở `canhbao.ts`. Chỗ gọi phải tra bảng TRƯỚC rồi mới đưa vào đây.
 */
export const duocPopup = (mucDo: 1 | 2 | null, laMat = false, popupMat = false) =>
  /* TK-32 B.4 — MỘT điều kiện mức thêm vào: Mất kết nối chỉ popup khi người dùng BẬT tuỳ chọn (mặc định tắt).
     Cảnh báo (mức 2 không phải mất kết nối) không bao giờ popup. Luật gom/bão bên dưới không đổi. */
  mucDo === 1 || (popupMat && laMat);

/** Quy tắc 5 — dọn nhịp cũ (ngoài 60 giây) rồi ghi thêm nhịp này. */
function capNhatNhip(nhip: number[], luc: number): number[] {
  return [...nhip.filter((t) => luc - t < NGUONG_BAO_MS), luc];
}

/**
 * Nhận MỘT cảnh báo mức 1 và trả về trạng thái mới.
 *
 * ⚠ THUẦN: không sửa `tt` tại chỗ, không đọc đồng hồ. `luc` đến từ chính cảnh báo, nên phép
 *   thử ép được cả cửa sổ 5 giây lẫn ngưỡng bão bằng cách cho số.
 */
export function nhan(tt: TrangThaiPopup, cb: CanhBaoToi): TrangThaiPopup {
  if (!duocPopup(cb.mucDo, cb.laMat, cb.popupMat)) return tt;

  /* Đang bão thì mọi cái mới chỉ làm dải to thêm, không đẻ popup. */
  if (tt.bao) {
    return { ...tt, bao: { ...tt.bao, tu: new Set([...tt.bao.tu, cb.cabinetId]) } };
  }

  const dat = (p: Popup): Popup => ({
    ...p,
    tu: new Set([...p.tu, cb.cabinetId]),
    idMoiNhat: cb.id,
    moTa: cb.message ?? p.moTa,
    capNhatLuc: cb.luc,
  });

  /*
   * QUY TẮC 2 + 4 — cùng MÃ và còn trong cửa sổ 5 giây ⇒ gộp vào nhóm đang có.
   * Quy tắc 4 (*cùng tủ + cùng mã ⇒ CẬP NHẬT, không thêm*) rơi ra miễn phí: `tu` là `Set`.
   *
   * ⚠ Cửa sổ đo từ `capNhatLuc`, KHÔNG từ `moLuc`: một sự cố kéo dài 30 giây, mỗi 4 giây
   *   một tủ, là MỘT sự cố. Đo từ `moLuc` thì tới giây thứ 6 nó tách ra thành popup thứ hai
   *   trong khi vẫn là cùng một nguyên nhân.
   *
   * ⛔ Gộp thì KHÔNG động vào nhịp: không có nhóm mới nào được mở.
   */
  if (tt.dangHien && tt.dangHien.code === cb.code && cb.luc - tt.dangHien.capNhatLuc <= CUA_SO_GOM_MS) {
    return { ...tt, dangHien: dat(tt.dangHien) };
  }

  const i = tt.hangCho.findIndex((p) => p.code === cb.code && cb.luc - p.capNhatLuc <= CUA_SO_GOM_MS);
  if (i >= 0) {
    const hangCho = [...tt.hangCho];
    hangCho[i] = dat(hangCho[i]);
    return { ...tt, hangCho };
  }

  /* Tới đây thì đây LÀ một nhóm mới — và chỉ tới đây nhịp mới nhích. */
  const nhipNhomMoi = capNhatNhip(tt.nhipNhomMoi, cb.luc);

  /*
   * QUY TẮC 5 — BÃO. Quá nhiều THỨ KHÁC NHAU phải trình bày cùng lúc ⇒ thôi liệt kê.
   * ⚠ Vào chế độ bão thì dẹp cả popup đang hiện lẫn hàng chờ — để lại chúng là vừa có dải
   *   "sự cố diện rộng" vừa có popup từng cái, tức là tệ hơn cả hai cách.
   */
  if (nhipNhomMoi.length > NGUONG_BAO_SO) {
    return {
      dangHien: null, hangCho: [], nhipNhomMoi,
      bao: { tu: new Set([...gomTuTat(tt), cb.cabinetId]), tuLuc: tt.dangHien?.moLuc ?? cb.luc },
    };
  }

  const moi: Popup = {
    code: cb.code, tu: new Set([cb.cabinetId]), idMoiNhat: cb.id,
    moTa: cb.message ?? '', moLuc: cb.luc, capNhatLuc: cb.luc,
  };

  /* QUY TẮC 3 — một popup tại một thời điểm; cái sau vào hàng chờ, KHÔNG chồng cửa sổ. */
  return tt.dangHien
    ? { ...tt, nhipNhomMoi, hangCho: [...tt.hangCho, moi] }
    : { ...tt, nhipNhomMoi, dangHien: moi };
}

/** Mọi tủ đang có mặt ở popup đang hiện + hàng chờ — dùng khi chuyển sang chế độ bão. */
function gomTuTat(tt: TrangThaiPopup): Set<string> {
  const ra = new Set<string>();
  for (const p of [...(tt.dangHien ? [tt.dangHien] : []), ...tt.hangCho]) {
    for (const t of p.tu) ra.add(t);
  }
  return ra;
}

/**
 * QUY TẮC 6 — người trực bấm xác nhận. **Mức 1 không tự tắt**, nên đây là cửa DUY NHẤT
 * đóng một popup, và chỗ gọi phải ghi cái bấm ấy vào nhật ký (`POST /api/alarms/:id/ack`,
 * cột `ackedById`/`ackedAt` đã có sẵn — không đẻ bảng mới).
 */
export function xacNhan(tt: TrangThaiPopup): { tt: TrangThaiPopup; idCanGhi: string | null } {
  if (!tt.dangHien) return { tt, idCanGhi: null };
  const [ke, ...con] = tt.hangCho;
  return {
    tt: { ...tt, dangHien: ke ?? null, hangCho: ke ? con : [] },
    idCanGhi: tt.dangHien.idMoiNhat,
  };
}

/** Người trực bấm "Đã xem" trên dải bão. Dải là MỘT thứ, đóng một lần. */
export const dongBao = (tt: TrangThaiPopup): TrangThaiPopup => ({ ...tt, bao: null, nhipNhomMoi: [] });

/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * 🔴 QUY TẮC 7 — TỦ BÁO ĐÃ HẾT ⇒ RÚT TỦ ẤY KHỎI POPUP. YC-47, dev_device bắt bằng mốc
 *   `safetyCut = 0` lúc 12:25:47 trong khi băng vẫn nằm trên màn hình.
 *
 * ⛔ Trước hàm này, `xacNhan()` tự nhận là *"cửa DUY NHẤT đóng một popup"* — và câu ấy đúng,
 *   nhưng nó **mâu thuẫn với chữ app in cho người trực**: `cauChanPopup()` hứa *"Cảnh báo này
 *   TỰ TẮT khi tủ báo đã hết"*, và `SAFETY_CUT` nằm trong `MA_TU_TAT`. App **nói một hành
 *   động nó không làm** — đúng hạng YC-47.
 *
 * ⚠ RÚT TỪNG TỦ, KHÔNG XOÁ CẢ NHÓM: khoá gom là **mã**, nên một popup `SAFETY_CUT` có thể
 *   đang chở 40 tủ. Tủ số 7 hết cắt **không** có nghĩa 39 tủ kia hết. Xoá cả nhóm ở đây là
 *   đổi một băng kẹt lấy một băng biến mất khi vấn đề còn nguyên — hỏng về phía NGUY.
 * ⇒ Nhóm chỉ biến mất khi tủ CUỐI CÙNG rút ra.
 *
 * ⚠ Và dải BÃO **không** bị hàm này chạm tới: bão là *"quá nhiều thứ khác nhau"*, một tủ hết
 *   một mã không trả lời được câu đó. Dải bão vẫn đóng bằng `dongBao()` như cũ.
 *
 * ⚠ THUẦN như mọi luật khác trong tệp này: không đồng hồ, không React.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
export function tuBaoDaHet(tt: TrangThaiPopup, cabinetId: string, code: string): TrangThaiPopup {
  const rut = (p: Popup): Popup | null => {
    if (p.code !== code || !p.tu.has(cabinetId)) return p;
    const tu = new Set(p.tu);
    tu.delete(cabinetId);
    return tu.size === 0 ? null : { ...p, tu };
  };

  const hienMoi = tt.dangHien ? rut(tt.dangHien) : null;
  const choMoi = tt.hangCho.map(rut).filter((p): p is Popup => p !== null);

  /* Cái đang hiện rỗng đi thì cái đầu hàng chờ lên thay — đúng quy tắc 3, y như `xacNhan`. */
  if (hienMoi === null && tt.dangHien !== null) {
    const [ke, ...con] = choMoi;
    return { ...tt, dangHien: ke ?? null, hangCho: ke ? con : [] };
  }
  return { ...tt, dangHien: hienMoi, hangCho: choMoi };
}

/* ──────────────────────────────────────────────────────────────────────────── câu chữ */

/**
 * Câu trên popup. Một tủ thì nói tên sự việc; nhiều tủ thì nói **con số và nguyên nhân**.
 *
 * ⛔ KHÔNG bao giờ gộp nhiều MÃ vào một câu. dev_device: *"'3 tủ có vấn đề' là một câu vô
 *   dụng… gom khác mã thì họ phải mở ra đọc, và lúc đó popup chỉ còn là một cái cửa chắn."*
 *   Cấu trúc dữ liệu ở trên đã cấm chuyện đó (khoá gom LÀ `code`); câu này chỉ không được
 *   phá lại điều ấy.
 */
export function cauPopup(p: Popup, nhanMa: string): string {
  const n = p.tu.size;
  if (n === 1) return nhanMa;
  const giay = Math.max(1, Math.round((p.capNhatLuc - p.moLuc) / 1000));
  return `${n} tủ — ${nhanMa} trong ${giay} giây`;
}

export function cauBao(bao: { tu: Set<string>; tuLuc: number }, bayGio: number): string {
  const phut = Math.max(1, Math.round((bayGio - bao.tuLuc) / 60_000));
  return `SỰ CỐ DIỆN RỘNG — ${bao.tu.size} tủ, đang tiếp tục (${phut} phút)`;
}
